import { useState } from "react";
import { Button, Icon } from "@conuti-das/prince-ui";
import { princeIcon } from "@/ui-prince";
import { enqueueStage, cancelJob } from "@/api/jobs";
import { ApiError } from "@/api/client";
import { LiveLogDrawer } from "./LiveLogDrawer";
import { AwaitingUserModal } from "./AwaitingUserModal";

export function StageActions({ runId, stage, state, jobId, onChanged }: {
  runId: string; stage: string; state: string; jobId?: string | null;
  onChanged: () => void;
}) {
  const [drawerOpen, setDrawer] = useState(false);
  const [activeJobId, setActiveJobId] = useState<string | null>(jobId ?? null);
  const [awaitingSlash, setAwaitingSlash] = useState<string | null>(null);
  const [awaitingJob, setAwaitingJob] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const canRun = ["pending", "planned", "failed", "cancelled", "skipped"].includes(state);
  const canCancel = ["queued", "running"].includes(state);
  const canRerun = state === "success";

  async function trigger() {
    setErr(null);
    try {
      const res = await enqueueStage(runId, stage, {});
      setActiveJobId(res.job_id);
      if (res.state === "awaiting_user" && res.slash_command) {
        setAwaitingJob(res.job_id);
        setAwaitingSlash(res.slash_command);
      } else {
        setDrawer(true);
      }
      onChanged();
    } catch (e) {
      if (e instanceof ApiError && e.status === 409) {
        const ex = e.body?.detail?.existing_job_id ?? e.body?.existing_job_id;
        const actor = e.body?.detail?.actor ?? e.body?.actor ?? "?";
        setErr(`Bereits aktiv: ${actor} (Job ${ex})`);
        if (ex) { setActiveJobId(ex); setDrawer(true); }
      } else {
        setErr(String((e as any).message ?? e));
      }
    }
  }
  async function abort() {
    if (!activeJobId) return;
    try { await cancelJob(activeJobId); onChanged(); }
    catch (e: any) { setErr(e.message); }
  }

  return (
    <div style={{ display: "flex", gap: "var(--s-1)", flexWrap: "wrap", marginTop: 8 }}>
      {canRun && <Button variant="filled" onPress={trigger}><Icon name={princeIcon("play")} size={16} />Ausführen</Button>}
      {canRerun && <Button variant="plain" onPress={trigger}><Icon name={princeIcon("refresh")} size={16} />Re-run</Button>}
      {canCancel && <Button variant="filled" onPress={abort}><Icon name={princeIcon("decline")} size={16} />Abbrechen</Button>}
      {activeJobId && <Button variant="plain" onPress={() => setDrawer(true)}><Icon name={princeIcon("log")} size={16} />Live-Log</Button>}
      {err && <span style={{ color: "var(--sapNegativeColor)", fontSize: "0.78rem" }}>{err}</span>}
      <LiveLogDrawer
        jobId={activeJobId} open={drawerOpen}
        onClose={() => setDrawer(false)}
        title={`${stage} (${runId})`}
      />
      {awaitingSlash && awaitingJob && (
        <AwaitingUserModal
          open={true}
          jobId={awaitingJob} slashCommand={awaitingSlash}
          onClose={() => { setAwaitingSlash(null); setAwaitingJob(null); }}
          onComplete={() => { setAwaitingSlash(null); setAwaitingJob(null); onChanged(); }}
        />
      )}
    </div>
  );
}
